var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAsterisk = function SvgAsterisk(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-8": 8,
    viewBox: "0 0 7.1 8.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.534 0c.132 0 .26.057.353.157.094.101.147.238.147.38v2.83l2.28-1.415a.48.48 0 0 1 .382-.056q.096.028.175.093a.565.565 0 0 1-.057.894l-2.28 1.414 2.28 1.415a.5.5 0 0 1 .149.138.55.55 0 0 1 .1.398.56.56 0 0 1-.192.357.49.49 0 0 1-.371.106.5.5 0 0 1-.185-.069L4.034 5.227v2.83c0 .142-.053.279-.147.38a.48.48 0 0 1-.353.157.48.48 0 0 1-.354-.157.56.56 0 0 1-.146-.38v-2.83L.753 6.642a.48.48 0 0 1-.38.056.5.5 0 0 1-.177-.093.565.565 0 0 1 .057-.894l2.28-1.414-2.28-1.415a.53.53 0 0 1-.23-.326.57.57 0 0 1 .05-.406.5.5 0 0 1 .302-.25.47.47 0 0 1 .378.052l2.28 1.415V.537c0-.142.054-.279.147-.38.094-.1.221-.157.354-.157"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAsterisk);
export default ForwardRef;